/***
 *
 * MDI 구조 menu list
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

// 각 페이지 타입 정의
export interface MenuItem {
  id: string;
  title: string;
  component?: React.FC | undefined;
  permission?: string;
  menu: {
    id: string;
    name: string;
    permission: string;
    // component?: React.FC;
  }[];
}

interface SetMenusState {
  tabs: Omit<MenuItem, "menu">[];
  activePageId: string | null;
  addTabs: (tabs: Omit<MenuItem, "menu">) => void;
  setActivePage: (id: string) => void;
  removeTabs: (id: string) => void;
  resetTabs: () => void;
  menuList: MenuItem[]; // 로그인 후 받은 메뉴 목록
  setMenuList: (menus: MenuItem[]) => void; // 로그인 후 메뉴 세팅
}

const useMdiStore = create<SetMenusState>()(
  persist(
    (set, get) => ({
      menuList: [],
      tabs: [],
      activePageId: null,

      // 로그인 후 받은 메뉴 리스트 등록
      setMenuList: (_menu) => {
        set({ menuList: _menu });
      },

      // 페이지 추가
      addTabs: (tab) => {
        const { tabs } = get();
        const exists = tabs.find((p) => p.id === tab.id);

        if (!exists) {
          set({ tabs: [...tabs, tab], activePageId: tab.id });
        } else {
          set({ activePageId: tab.id }); // 이미 열려 있으면 활성화만 변경
        }
      },

      // 활성 페이지 변경
      setActivePage: (id) => set({ activePageId: id }),

      // 페이지 닫기
      removeTabs: (id) => {
        const { tabs, activePageId } = get();
        const newPages = tabs.filter((p) => p.id !== id);

        let newActiveId = activePageId;
        if (activePageId === id) {
          // 현재 활성 페이지를 닫은 경우, 이전 페이지로 이동
          const lastPage = newPages[newPages.length - 1];
          newActiveId = lastPage ? lastPage.id : null;
        }

        set({ tabs: newPages, activePageId: newActiveId });
      },

      resetTabs: () => {},
    }),
    {
      name: "mdi-storage", // localStorage 키 이름
      partialize: (state) => ({
        tabs: state.tabs,
        activePageId: state.activePageId,
        menuList: state.menuList,
      }),
    }
  )
);

export default useMdiStore;
